import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaPergunta = (): TabelaColuna => ({
  Chave: 'pergunta',
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Pergunta</div>
})
